import { Component, OnInit, Input, EventEmitter, OnDestroy, HostListener } from '@angular/core';
import { Subscription } from 'rxjs';
import { SortableColumnService } from './sortableColumn.service';


@Component({
    selector: '[sortable-column]',
    templateUrl: './sortableColumn.component.html'
})
export class SortableColumnComponent implements OnInit, OnDestroy {

    @Input('sortable-column')
    columnName: string;
    @Input('sort-direction')
    sortDirection: string = '';
    @Input('is-numeric')
    isNumeric: boolean = false;
    private columnSortedSubscription: Subscription;

    constructor(private sortService: SortableColumnService) { }

    @HostListener('click')
    sort() {
        console.log('->>-> HostListener: Click on Column...');
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
        this.sortService.columnSorted({ sortColumn: this.columnName, sortDirection: this.sortDirection, isNumeric: this.isNumeric });

    }

    ngOnInit() {
        // subscribe to sort changes so we can react when other columns are sorted
        this.columnSortedSubscription = this.sortService.columnSorted$.subscribe(event => {

            // console.log('->>-> columnName = ' + this.columnName);
            // console.log('->>-> event.sortColumn = ' + event.sortColumn);

            // reset this column's sort direction to hide the sort icons
            if (this.columnName !== event.sortColumn) {
                this.sortDirection = '';
            }
        });
    }

    ngOnDestroy() {
        this.columnSortedSubscription.unsubscribe();
    }
}
